import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { ModalService } from '../../../../services/modal.service';

import { CampaignYearPipe } from '../../../../pipes/campaignYear.pipe';
import { ARColzaCampaign, ARColzaCampaignConfiguration } from '../../../../models/agrorendement-colza.model';
import { ARColzaService } from '../../../../services/agrorendement-colza.service';
import { correctDate, showErrorMessage } from '../../../../utils/utils';
import { TranslatePipe } from '../../../../pipes/translate.pipe';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

@Component({
  standalone: true,
  selector: 'ar-colza-campaign-config-edit',
  templateUrl: 'campaign-config-edit.component.html',
  imports: [RouterLink, RouterLinkActive, RouterOutlet, CampaignYearPipe, TranslatePipe, CommonModule, FormsModule, BsDatepickerModule],
  providers: [ARColzaService],
})
export class ARColzaCampaignConfigurationEditComponent implements OnInit, OnDestroy {
  @Input() config: ARColzaCampaignConfiguration;
  @Output() close = new EventEmitter();
  error: any;
  sub: any;

  edited = false;

  configId: number;
  isStartingOnCollapsed: boolean = false;
  isEndingOnEhCollapsed: boolean = false;
  isEndingOnShCollapsed: boolean = false;
  campaign: ARColzaCampaign;

  constructor(
    private colzaService: ARColzaService,
    private modal: ModalService,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  goBack(savedConfig: ARColzaCampaignConfiguration = null) {
    this.close.emit(savedConfig);
    this.router.navigate(['/orders', 'azote', 'colza', 'admin']);
    return false;
  }

  save() {
    if (this.config.startingOn) {
      this.config.startingOn = correctDate(<Date>this.config.startingOn);
    }

    if (this.config.endingOnEh) {
      this.config.endingOnEh = correctDate(<Date>this.config.endingOnEh);
    }

    if (this.config.endingOnSh) {
      this.config.endingOnSh = correctDate(<Date>this.config.endingOnSh);
    }

    this.colzaService.saveCampaignConfiguration(this.config).subscribe(
      (config) => {
        this.config = config;
        this.goBack(config);
      },
      (error) => this.handleSaveError(error),
    );
  }

  ngOnInit() {
    this.sub = this.route.params.subscribe((params) => {
      if (this.route.snapshot.url[4].path === 'new') {
        this.edited = false;
        this.config = new ARColzaCampaignConfiguration();
        this.config.campaign = new ARColzaCampaign();
        if (params['campaignId']) {
          this.config.campaign.id = +params['campaignId'];
          this.getCampaign(this.config.campaign.id);
        } else {
          showErrorMessage(this.modal, 'Pas de campagne spécifiée').then((r) => {
            this.router.navigate(['/orders', 'azote', 'colza', 'admin']);
          });
        }
        this.isStartingOnCollapsed = true;
        this.isEndingOnEhCollapsed = true;
        this.isEndingOnShCollapsed = true;
      } else if (this.route.snapshot.url[4].path === 'edit') {
        this.configId = +params['configId'];
        this.edited = true;
        // FIXME traiter les erreurs ; afficher un message
        this.colzaService.getCampaignConfiguration(this.configId).subscribe(
          (config) => {
            this.config = config;
            this.campaign = config.campaign;
          },
          (e) => this.handleGetError(e),
        );
      }
    });
  }

  getCampaign(campaignId: number) {
    this.colzaService.getCampaign(campaignId).subscribe(
      (campaign) => {
        this.campaign = campaign;
      },
      (error) => this.handleGetError(error),
    );
  }

  handleSaveError(error: any) {
    if (error.status === 401) {
      showErrorMessage(this.modal, "Vous n'êtes pas autorisé à modifier cette configuration");
    } else {
      // FIXME détailler les erreurs du formulaire
      // FIXME définir un format pour les erreurs de validation
      console.error(error);
      showErrorMessage(this.modal, 'Il y a des erreurs dans le formulaire');
    }
  }

  handleGetError(error: any) {
    if (error.status === 401) {
      showErrorMessage(this.modal, "Vous n'êtes pas autorisé à consulter cette configuration").then((r) => {
        this.router.navigate(['/orders', 'azote']);
      });
    } else {
      console.error(error);
      showErrorMessage(this.modal, 'Une erreur est survenue').then((r) => {
        this.router.navigate(['/orders', 'azote', 'colza', 'admin']);
      });
    }
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
